import { ThemeContext } from "./ThemeContext";
import { darkTheme } from "./dark-theme";
import { ThemeContextProviderProps } from "./ThemeContextProviderProps.types";
import CssBaseline from "@mui/material/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { PaletteMode, createTheme } from "@mui/material";
import React from "react";
import { getDesignTokens } from "./getDesignTokens";

export const ThemeContextProvider = function ({ children }: ThemeContextProviderProps) {
  const [mode, setMode] = React.useState<PaletteMode>(() => {
    return (localStorage.getItem(COLOR_MODE_KEY) as any) || "dark";
  });
  const colorMode = React.useMemo(
    () => ({
      // The dark mode switch would invoke this method
      toggleColorMode: () => {
        setMode((prevMode: PaletteMode) => {
          var newMode: PaletteMode = prevMode === "light" ? "dark" : "light";
          localStorage.setItem(COLOR_MODE_KEY, newMode);
          return newMode;
        });
      },
    }),
    []
  );

  // Update the theme only if the mode changes
  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);
  return (
    <ThemeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
const COLOR_MODE_KEY = "COLOR_MODE";
